/* eslint-disable no-nested-ternary */
import { isNumber } from 'lodash';
import React, { useEffect, useState } from 'react';
import MapService from 'services/api/map.service';
import { IUserAddress } from 'types/user';
import { formatAddress } from 'utils';

interface IMapDirection {
  from?: IUserAddress;
  to?: IUserAddress;
  style?: React.CSSProperties;
  location?: IUserAddress;
  interactable?: boolean;
  hideDirectionBox?: boolean;
}
// function regexIndexOf(string: any, regex: any, startpos: any) {
//   const indexOf = string.substring(startpos || 0).search(regex);
//   return indexOf >= 0 ? indexOf + (startpos || 0) : indexOf;
// }

const getMapPlusCodeFromCoordinate = async (coordinate?: number[]) => {
  let plusCodeLink = '';
  if (coordinate && coordinate[0] && coordinate[1]) {
    const response = await MapService.getMapPlusCodeFromCoordinate([...coordinate].reverse());
    plusCodeLink = response.data?.plus_code?.global_code;
  }
  return plusCodeLink;
};

const checkIsCoordinateValid = (coordinate?: number[]) => {
  if (!coordinate) return false;
  return coordinate.every((c) => !!c);
};

const MapDirection: React.FC<IMapDirection> = ({ from, to, style = {}, location, hideDirectionBox }) => {
  const [codeState, setCodeState] = useState({
    from: formatAddress(from),
    to: formatAddress(to),
    location: formatAddress(location),
  });

  useEffect(() => {
    if (checkIsCoordinateValid(from?.coordinate) && checkIsCoordinateValid(to?.coordinate)) {
      getMapPlusCodeFromCoordinate(from?.coordinate).then((res) => {
        if (res) setCodeState((c) => ({ ...c, from: res }));
      });
      getMapPlusCodeFromCoordinate(to?.coordinate).then((res) => {
        if (res) setCodeState((c) => ({ ...c, to: res }));
      });
    } else {
      setCodeState((c) => ({ ...c, from: formatAddress(from), to: formatAddress(to) }));
    }
    if (checkIsCoordinateValid(location?.coordinate)) {
      getMapPlusCodeFromCoordinate(location?.coordinate).then((res) => {
        if (res) setCodeState((c) => ({ ...c, location: res }));
      });
    } else {
      setCodeState((c) => ({ ...c, location: formatAddress(location) }));
    }
  }, [formatAddress(from), formatAddress(to), formatAddress(location)]);

  const getMapSrc = () => {
    let mapSrc = '';
    if (codeState.from && codeState.to) {
      mapSrc = `https://www.google.com/maps/embed/v1/directions?key=${
        process.env.REACT_APP_GMAP_API_KEY || 'AIzaSyDD9jM4M1uHIN53QOBg7vACnJIDbtCTvAM'
      }&origin=${encodeURIComponent(codeState.from)}&destination=${encodeURIComponent(
        codeState.to,
      )}&avoid=tolls|highways`;
    } else if (codeState.location) {
      // const regexp = new RegExp(/\d/);
      // const tempLoc = location.substr(regexIndexOf(location, regexp, 0));

      mapSrc = `https://www.google.com/maps/embed/v1/place?key=${
        process.env.REACT_APP_GMAP_API_KEY || 'AIzaSyDD9jM4M1uHIN53QOBg7vACnJIDbtCTvAM'
      }&q=${encodeURIComponent(codeState.location)}&zoom=10`;
    }

    return mapSrc;
  };

  const { height, width, minWidth, minHeight } = style;
  const fullHeightText = isNumber(height) ? `${height}px` : height;

  const topLeftMapBoxSize = 135;
  if (!(from && to) && !location) return null;

  return (
    <div className='overflow-hidden' style={{ width, height, minWidth, minHeight }}>
      {!location && (
        <iframe
          title='direction'
          frameBorder='0'
          style={{
            border: 0,
            position: 'relative',
            top: hideDirectionBox ? -topLeftMapBoxSize : undefined,
            ...style,
            minWidth: width,
            height: `calc(${fullHeightText} + ${topLeftMapBoxSize}px)`,
          }}
          src={getMapSrc()}
          allowFullScreen
        />
      )}
      {location && (
        <iframe
          style={{
            border: 0,
            position: 'relative',
            top: hideDirectionBox ? -topLeftMapBoxSize : undefined,
            ...style,
            minWidth: width,
            height: `calc(${fullHeightText} + ${topLeftMapBoxSize}px)`,
          }}
          src={getMapSrc()}
          title='Location of appointment'
        />
      )}
    </div>
  );
};

export default MapDirection;
